/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Box, Button, FormField, Input, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { i18nKeys } from '../../utils/i18n.utils';

export interface ConfirmModalProps {
  title?: string;
  label?: string;
  message?: string | React.ReactElement;
  confirmBtnLabel?: string;
  cancelBtnLabel?: string;
  visible: boolean;
  size?: 'small' | 'medium' | 'large';
  textInput?: string;
  onTextInput?: (input: string) => any;
  disabled?: boolean;
  loading?: boolean;
  onCancel?: () => any;
  onConfirm: () => any;
  onDismiss?: () => any;
  errorText?: string;
  constraintText?: string;
  cancelButtonId?: string;
  submitButtonId?: string;
  'data-testid'?: string;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  label,
  message,
  confirmBtnLabel,
  cancelBtnLabel,
  visible,
  size,
  textInput,
  onTextInput,
  onCancel,
  onDismiss = onCancel,
  onConfirm,
  disabled = false,
  loading = false,
  errorText = '',
  constraintText = '',
  cancelButtonId,
  submitButtonId,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      visible={visible}
      size={size || 'medium'}
      header={title || t(i18nKeys.general.confirm)}
      onDismiss={onDismiss}
      closeAriaLabel={t(i18nKeys.general.close)}
      data-testid={rest['data-testid']}
      footer={
        <Box float="right" className="awsui-util-f-r">
          <SpaceBetween direction="horizontal" size="xxs">
            {onCancel && (
              <Button
                key="cancel-button"
                id={cancelButtonId ?? 'cancel-button'}
                data-testid={cancelButtonId ?? 'cancel-button'}
                onClick={() => onCancel()}
                variant="link"
              >
                {cancelBtnLabel || t(i18nKeys.general.cancel)}
              </Button>
            )}
            <Button
              key="submit-button"
              id={submitButtonId ?? 'submit-button'}
              data-testid={submitButtonId ?? 'submit-button'}
              onClick={() => onConfirm()}
              disabled={disabled}
              loading={loading}
              variant="primary"
            >
              {confirmBtnLabel || t(i18nKeys.general.confirm)}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size={'s'}>
        <span key="message">{message || t(i18nKeys.general.areYouSure)}</span>

        {textInput !== undefined && onTextInput !== undefined && (
          <FormField
            key="formField"
            label={label || ''}
            errorText={errorText}
            i18nStrings={{ errorIconAriaLabel: t(i18nKeys.general.error) }}
            constraintText={constraintText}
          >
            <Input onChange={({ detail }) => onTextInput(detail.value)} value={textInput} />
          </FormField>
        )}
      </SpaceBetween>
    </Modal>
  );
};
